export const shuffleMarqueeNames = (values, random = Math.random) => {
  const result = [...new Set((values || []).filter(Boolean))];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  if (result.length > 2 && values?.length === result.length && result.every((value, index) => value === values[index])) {
    result.push(result.shift());
  }
  return result;
};
